/**
 * @file: erpSyncLabels.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * User-facing names for the ERP sync vocabulary. Kept in one place because
 * the same words appear on the management screen, the sync screen and the
 * log list, and three copies would drift.
 */

import {
  ErpIntegrationType,
  ErpSyncDirection,
  ErpSyncResult,
  ErpSyncType,
} from '@euler/model/enum';

/** How an integration reaches the ERP. */
export const kErpIntegrationTypeLabel: Record<ErpIntegrationType, string> = {
  [ErpIntegrationType.Openapi]: '接口对接',
  [ErpIntegrationType.Extension]: '浏览器插件',
  [ErpIntegrationType.Hosted]: '云端托管',
};

/**
 * Which way an order moved. Phrased as a destination rather than
 * inbound/outbound, which reads as jargon to a shop.
 */
export const kErpSyncDirectionLabel: Record<ErpSyncDirection, string> = {
  [ErpSyncDirection.Inbound]: '同步到知车',
  [ErpSyncDirection.Outbound]: '同步到ERP',
};

export const kErpSyncResultLabel: Record<ErpSyncResult, string> = {
  [ErpSyncResult.Success]: '成功',
  [ErpSyncResult.Failed]: '失败',
};

/** Whether a person asked for the sync or the system ran it. */
export const kErpSyncTypeLabel: Record<ErpSyncType, string> = {
  [ErpSyncType.Automatic]: '自动',
  [ErpSyncType.Manual]: '手动',
};
